import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {checkAndSetError, clearInputFormErrorFields, inputFormIsValid} from "../../../../Components/Inputs";
import {OWN_QUEUE_STATUS} from "./ownQueueConstants";

export const filterQueueByStatus = (queue: Record<string, any>[], isPending = true) => {
return queue.filter((q: Record<string, any>) =>
        isPending
            ? q.ownQueueStatus === OWN_QUEUE_STATUS.Pending
            : q.ownQueueStatus === OWN_QUEUE_STATUS.InReview
    );
};


export function getTotalCost(ownQueue: Record<string, any>[]) {
if (isArrayNullOrEmpty(ownQueue))
    return 0;

const totalCost = ownQueue.reduce((total: number, item: Record<string, any>) => total + (item.ownCatalogItem.cost || 0), 0);
    return convertToCurrencyFormat(totalCost);
}

export function convertToCurrencyFormat(value: string | number) {
    if (isNaN(Number(value)) || isNullOrUndefined(value)) {
        return "";
    }
    return `$ ${parseFloat(String(value)).toFixed(2)}`;
}

export function isOwnLoanFormValid(ownLoanForm: Record<string, any>) {
    clearInputFormErrorFields(ownLoanForm);
    checkAndSetError([
        ownLoanForm.shippingLocationId,
    ]);

    return inputFormIsValid(ownLoanForm);
}
